import $ from "jquery";
import Waves from "./system/waves.js";

window.Waves = Waves;
window.jQuery = window.$ = $;